import React from "react";
import CTE from "../Constants";
function ChatOptions(props) {
    return (
        <div className="opt-chat-options">
            <ul className="opt-chat-options__list">
                {props.options.map((option, index) => (
                    <li
                        key={index}
                        className="opt-chat-options__item"
                        onClick={() => props.selectOptionCb(CTE.CONTENT_TYPE.OPTIONS, option)}
                    >
                        <span className="opt-chat-options__link">{option.buttonText}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
export default ChatOptions;
